import { Select } from "antd";
import type { FormItemProps, SelectProps } from "antd";
import type { BaseSelectRef } from "rc-select";
import { forwardRef, useRef, useState } from "react";
import { FormItem } from "./FormItem";
import { useTranslation } from "utils/hooks";

export type FormSelectHandle = BaseSelectRef;
export interface FormSelectProps
  extends Omit<FormItemProps, "name">,
    Pick<
      SelectProps,
      | "size"
      | "placeholder"
      | "options"
      | "mode"
      | "onInputKeyDown"
      | "onSearch"
      | "filterOption"
      | "disabled"
      | "labelInValue"
      | "onChange"
      | "allowClear"
      | "loading"
      | "optionRender"
      | "labelRender"
    > {
  name: string | number | (string | number)[];
  formItemStyle?: React.CSSProperties;
  showLabel?: boolean;
}
export const FormSelect = forwardRef<FormSelectHandle, FormSelectProps>(
  (
    {
      name,
      label,
      rules,
      options = [],
      size,
      placeholder,
      formItemStyle,
      mode,
      onInputKeyDown,
      onSearch,
      filterOption,
      disabled,
      labelInValue,
      onChange,
      showLabel = true,
      allowClear,
      loading,
      labelRender,
      optionRender,
      ...props
    },
    ref
  ) => {
    const [dropdownOpen, setDropdownOpen] = useState<boolean>();

    const { t } = useTranslation("form");

    return (
      <FormItem
        name={name}
        label={showLabel && label}
        rules={rules}
        style={formItemStyle}
        {...props}
      >
        <Select
          ref={ref}
          size={size}
          placeholder={placeholder ?? t("pleaseSelect", { name: label })}
          mode={mode}
          options={options}
          onChange={onChange}
          onInputKeyDown={onInputKeyDown}
          onSearch={onSearch}
          filterOption={filterOption}
          open={dropdownOpen}
          disabled={disabled}
          labelInValue={labelInValue}
          allowClear={allowClear}
          loading={loading}
          labelRender={labelRender}
          optionRender={optionRender}
        />
      </FormItem>
    );
  }
);

FormSelect.displayName = "FormSelect";
